/**
 * The words on the nav rail and the top bar's page name.
 *
 * Keys, not words, so the nav array never holds a domain term of its own.
 * These are display keys only: the stored `nav_tabs` keys and the URL paths
 * are separate and do not change.
 */
import type { Vocab } from './vocab';

export type NavLabelKey =
  | 'home'
  | 'records'
  | 'leads'
  | 'segments'
  | 'people'
  | 'companies'
  | 'deals'
  | 'tasks'
  | 'workflows'
  | 'imports'
  | 'email'
  | 'reports'
  | 'returns'
  | 'statements'
  | 'routing'
  | 'campaigns'
  | 'destinations'
  | 'routes'
  | 'data'
  | 'setUp'
  | 'money'
  | 'buyers'
  | 'suppliers'
  | 'activity'
  | 'alerts'
  | 'more'
  | 'settings';

export function navLabel(v: Vocab, key: NavLabelKey): string {
  switch (key) {
    case 'home': return 'Home';
    // The records page, named for its rows. The people behind them have
    // their own item, People.
    case 'records': return v.Many('lead');
    case 'leads': return v.Many('lead');
    // A segment is a saved filter, not a domain record.
    case 'segments': return 'Segments';
    case 'people': return v.Many('person');
    case 'companies': return v.Many('company');
    case 'deals': return v.Many('deal');
    case 'tasks': return v.Many('task');
    case 'workflows': return v.Many('workflow');
    case 'imports': return 'Imports';
    case 'email': return 'Email';
    case 'reports': return v.p.reports;
    case 'returns': return 'Returns';
    case 'statements': return 'Statements';
    case 'routing': return v.p.routing;
    case 'campaigns': return v.Many('campaign');
    // The transport records (where to send, how): Endpoints.
    case 'destinations': return v.Many('destination');
    // Every route of every stream. The menu item that used to open
    // Destinations, under the same `destinations` nav tab.
    case 'routes': return v.Many('route');
    // The menu's headings.
    case 'data': return 'Data';
    case 'setUp': return 'Set up';
    case 'money': return 'Money';
    case 'buyers': return v.p.dataBuyers;
    case 'suppliers': return v.p.dataSellers;
    case 'activity': return 'Activity';
    case 'alerts': return 'Alerts';
    case 'more': return 'More';
    case 'settings': return 'Settings';
  }
}
